import { SaveCurrentPositionDataDto } from '../dtos/save-current-position-data.dto';
import { SaveCurrentPositionData } from '../models/save-current-position-data';

/**
 * Map to save current position dto from model.
 * @param {SaveCurrentPositionData} data Model data.
 * @returns {SaveCurrentPositionDataDto}
 */
function toCreationDto(data) {
  return new SaveCurrentPositionDataDto({
    name: data.name,
    course_id: data.courseId,
    language_id: data.languageId,
  });
}

export const saveCurrentPositionDataMapper = {
  toCreationDto,
};
